






































































































































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import { gmapApi } from 'vue2-google-maps'

settings =
  name: 'VenueMapSelector'

  vue:
    props: ['value']

    data: ->
      location: @value
      form: null
      displayForm: true

      search: ''
      autocomplete: null

      infoWindow:
        opened: false
        options:
          pixelOffset:
            width: 0,
            height: -10

      isFullscreenActive: false
      fullscreenListener: null

      hiPolygonChangedDebounced: null

      # placeholder polygon animation
      animationCurrentValue: 0.3
      startValue: 0.3
      targetValue: 0.6
      step: 0.01
      animationInterval: 50  # Time in milliseconds
      animating: false
      lastTimestamp: 0
      direction: 1

    computed:
      google: -> gmapApi()

      initialMapZoom: -> 19
      initialMapCenter: ->
        lat: 40.6971494
        lng: -73.9972236

      mapOptions: ->
        draggable: true
        zoomControl: true
        mapTypeId: 'satellite'
        mapTypeControlOptions:
          position: 11 # google.maps.ControlPosition.BOTTOM_CENTER
        controlSize: 30
        tilt: 0
        scaleControl: true
        streetViewControl: false
        rotateControl: false
        fullscreenControl: true
        disableDefaultUi: true

      mapPlaceholderPolygonOptions: ->
        strokeColor: '#3d4852'
        strokeOpacity: @animationCurrentValue
        strokeWeight: 3
        fillColor: '#3d4852'
        fillOpacity: @animationCurrentValue

      mapPolygonOptions: ->
        strokeColor: '#13A7C1'
        strokeOpacity: 0.8
        strokeWeight: 3
        fillColor: '#13A7C1'
        fillOpacity: 0.35

      autocompleteOptions: ->
        fields: ['address_components', 'geometry']
        types: ['address']
        strictBounds: false
        componentRestrictions: { country: 'us' }

      formatAddressLine1: -> @compact([@location.street, @location.city]).join(', ')
      formatAddressLine2: -> @compact([@location.state, @location.zip]).join(', ')
      formatAddressLine3: -> @compact([@location.country]).join(', ')

      isEdittingVenue: -> !!@form
      hasLocationSelected: -> [@location.street, @location.city, @location.state, @location.zip].some(Boolean)
      hasLatLng: -> !!@location.geo_coordinates?.length
      hasPolygon: -> !!@location.geo_polygons?.length
      isGeofenceTrusted: -> !!@location?.geo_fence_trusted

      latLng: ->
        return null unless @hasLatLng
        [lng, lat] = @location.geo_coordinates
        { lat, lng }

      polygon:
        set: (polygon) -> @location.geo_polygons = [{ coordinates: polygon }]
        get: -> @location.geo_polygons?[0]?.coordinates

    mounted: ->
      @hiPolygonChangedDebounced = @debounce @hiPolygonChanged, 300
      @registerFullscreenListener()
      @initializeAutoCompleteInput()
      @resetMapCenter()
      window.requestAnimationFrame(@animatePlaceholderPolygon)

    destroyed: ->
      @removeFullscreenListener()

    methods:
      inputChanged: ->
        @$emit 'input', @location

      # fullscreen control
      hiToggleFullscreen: ->
        @toggleFullscreenMode()

      registerFullscreenListener: ->
        @removeFullscreenListener()
        @fullscreenListener = () => @onFullscreenChanged()
        document.addEventListener 'fullscreenchange', @fullscreenListener

      removeFullscreenListener: ->
        document.removeEventListener 'fullscreenchange', @fullscreenListener if @fullscreenListener

      toggleFullscreenMode: ->
        document.querySelector('.gm-style .gm-fullscreen-control').click()

      onFullscreenChanged: ->
        @isFullscreenActive = document.fullscreen
        @infoWindow.opened = @isFullscreenActive
        @resetMapCenter()

      # address form editing
      hiEditLocation: ->
        @startEditingLocation()

      hiSaveLocationForm: ->
        @stopEditingLocation()

      hiCancelEditingLocationForm: ->
        @cancelEditingLocation()

      startEditingLocation: ->
        @form = JSON.parse(JSON.stringify(@location))

      stopEditingLocation: ->
        @setLocation @form
        @form = null

      cancelEditingLocation: ->
        @form = null

      # autocomplete
      initializeAutoCompleteInput: ->
        map = await @$refs.mapRef.$mapPromise
        @autocomplete = new google.maps.places.Autocomplete @$refs.search.$refs.input, @autocompleteOptions
        @autocomplete.bindTo 'bounds', map
        @autocomplete.addListener 'place_changed', @onPlaceChanged

      onPlaceChanged: ->
        { address_components: ac, geometry } = @autocomplete.getPlace() || {}
        return unless ac
        street_name   = @extractAddressComponent ac, 'route'
        street_number = @extractAddressComponent ac, 'street_number'
        street        = "#{street_number} #{street_name}".trim()
        city          = @extractAddressComponent ac, 'locality'
        city        ||= @extractAddressComponent ac, 'administrative_area_level_2'
        state         = @extractAddressComponent ac, 'administrative_area_level_1', 'short_name'
        zip           = @extractAddressComponent ac, 'postal_code'
        country       = @extractAddressComponent ac, 'country', 'short_name'

        { lat, lng } = geometry.location.toJSON()
        geo_coordinates = [lng, lat]
        geo_polygons = []
        geo_fenced = false
        timezoneData = await RecessAPI.getTimeZone { lat, lng }
        timezone = timezoneData?.timeZoneId

        @search = ''
        @cancelEditingLocation()
        @setLocation { street, city, state, zip, country, geo_coordinates, geo_polygons, geo_fenced, timezone }
        @resetMapCenter() # depends on new geo coordinates set in the location object

      setLocation: (location) ->
        @location =
          timezone: location.timezone
          street: location.street
          city: location.city
          state: location.state
          zip: location.zip
          country: location.country
          geo_coordinates: location.geo_coordinates
          geo_polygons: location.geo_polygons
          geo_fenced: location.geo_fenced
          geo_fence_trusted: location.geo_fence_trusted
        @inputChanged()

      # marker
      hiClickMarker: ({ latLng }) ->
        @infoWindow.opened = !@infoWindow.opened
        @displayForm = false

      hiMarkerChanged: ({ latLng }) ->
        @setLatLng latLng.toJSON()
        @inputChanged()

      setLatLng: ({ lat, lng }) ->
        @location.geo_coordinates = [lng, lat]

      # polygon
      hiClickPolygon: ({ latLng }) ->
        @infoWindow.opened = !@infoWindow.opened
        @displayForm = false

      hiDoubleClickPolygonVertex: ({ vertex }) ->
        @removePolygonVertex vertex
        @inputChanged()

      hiResetPolygon: ->
        @resetPolygon()
        @inputChanged()

      hiPolygonChanged: (mvcArray) ->
        paths = []
        for i in [0...mvcArray.getLength()]
          for j in [0...mvcArray.getAt(i).getLength()]
            point = mvcArray.getAt(i).getAt(j)
            paths.push { lat: point.lat(), lng: point.lng() }
        @polygon = paths
        @location.geo_fenced = true
        @location.geo_fence_trusted = true
        @inputChanged()

      resetPolygon: ->
        @location.geo_polygons = []
        @location.geo_fenced = false

      removePolygonVertex: (vertex) ->
        return unless @polygon.length > 3
        @polygon = @polygon.filter((el, index) => index isnt vertex)
        @location.geo_fenced = true
        @location.geo_fence_trusted = true

      animatePlaceholderPolygon: (timestamp) ->
        unless @lastTimestamp
          @lastTimestamp = timestamp

        @timeElapsed = timestamp - @lastTimestamp

        if @timeElapsed >= @animationInterval and not @animating
          @animating = true
          @animationCurrentValue += @step * @direction

          if @animationCurrentValue >= @targetValue
            @direction = -1
          else if @animationCurrentValue <= @startValue
            @direction = 1

          @lastTimestamp = timestamp
          @animating = false

        window.requestAnimationFrame(@animatePlaceholderPolygon)

      # geofence trust
      hiUntrustGeofence: ->
        @location.geo_fence_trusted = false
        @inputChanged()

      hiTrustGeofence: ->
        @location.geo_fence_trusted = true
        @inputChanged()

      # utils
      resetMapCenter: ->
        return unless @hasLatLng
        # move the center of the map slightly to the right
        { lat, lng } = @latLng
        center = { lat, lng: lng - 0.00045 }
        map = await @$refs.mapRef.$mapPromise
        map.setCenter center
        map.setZoom @initialMapZoom

      extractAddressComponent: (addressComponents, componentType, fromProp = 'long_name') ->
        return component[fromProp].trim() for component in addressComponents when componentType in component.types
        ''

      debounce: (cb, time) ->
        timer = null
        (...args) =>
          clearTimeout timer
          timer = setTimeout cb.bind(@, ...args), time

    watch:
      value: (value) ->
        @location = value

export default VueOptions.vue settings
